export default __webpack_public_path__ + "assets/1ea016904f6eed0b0ea8da866f6c1379/08.jpg";